import { render, staticRenderFns } from "./UserMyPageView.vue?vue&type=template&id=ea8f2c74&"
import script from "./UserMyPageView.vue?vue&type=script&lang=js&"
export * from "./UserMyPageView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports